import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetailsHotel, Price } from 'models/travelDetails';
import { getFormattedPrice } from 'utils/currency';

import {
  Title,
  Subtitle,
  PricePerDay,
  TotalPrice,
  Card,
  Divider,
  AmenitiesArea,
  AmenityItem,
  TextIsRefundable,
  TextIsNotRefundable,
  RefundableIcon,
  NonRefundableIcon,
  ColombiaTax,
  ContentRefundableItems,
} from './styles';

interface Props {
  hotel: TravelDetailsHotel;
  price: Price;
}
const RoomDetails = ({ hotel, price }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency: price.currencyCode, t });
    return formatted;
  };

  const roomDescription = hotel.roomType.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

  const { refundableType, ammenities } = hotel;

  return (
    <Card>
      <Title>{roomDescription}</Title>
      <Subtitle>
        {`${t('travelDetails.hotels.nights', {
          count: hotel.quantityDays,
        })}, ${t('hotelBookingInfo.guestQuantity', { count: 1 })}`}
      </Subtitle>
      <PricePerDay>
        {t('hotelsCard.nightPrice', {
          value: formattedPrice(price.valuePerNight || 0),
        })}
      </PricePerDay>
      <TotalPrice>{formattedPrice(price.total)}</TotalPrice>
      <Divider />
      <ColombiaTax>{t('travelDetails.hotels.colimbiaTax')}</ColombiaTax>
      <AmenitiesArea>
        {ammenities.map((amenity, index) => (
          <AmenityItem key={index}>{amenity}</AmenityItem>
        ))}
      </AmenitiesArea>
      {refundableType === 'refundable' ? (
        <ContentRefundableItems>
          <RefundableIcon />
          <TextIsRefundable>{t('travelDetails.hotels.roomRefundable')}</TextIsRefundable>
        </ContentRefundableItems>
      ) : (
        <TextIsNotRefundable>
          <NonRefundableIcon />
          {t('travelDetails.hotels.roomNonRefundable')}
        </TextIsNotRefundable>
      )}
    </Card>
  );
};

export default RoomDetails;
